module.exports = __webpack_public_path__ + "img/icn_right.29282594.svg";